import * as React from 'react';
import { useCallback } from 'react';

import { Button } from 'components/bootstrap';
import { Modal } from 'security-app/components/common/Modal';
import ReplaySearch from 'components/events/ReplaySearch';
import { useModalContext } from 'common/contexts';
import type { LayoutState } from 'views/components/contexts/SearchPageLayoutContext';

function ReplayEvent() {
  const { entity: securityEvent, setEntity, setModal } = useModalContext();
  const alertId = securityEvent.event.id;
  const definitionId = securityEvent.event.event_definition_id;

  const onCancel = useCallback(() => {
    setModal(null);
    setEntity(null);
  }, [setEntity, setModal]);

  const searchPageLayout: Partial<LayoutState> = {
    sidebar: {
      isShown: false,
    },
    synchronizeUrl: false,
  } as const;

  return (
    <Modal
      show
      maxWidth="1500px"
      title="Replay Event"
      onClose={onCancel}
      closeOnBackdrop
      buttons={
        <Button bsStyle="primary" onClick={onCancel}>
          Close
        </Button>
      }>
      <ReplaySearch
        searchPageLayout={searchPageLayout}
        alertId={alertId}
        definitionId={definitionId}
        forceSidebarPinned
      />
    </Modal>
  );
}

export default ReplayEvent;
